import { render } from "./report.vue?vue&type=template&id=4b9f496f"
import script from "./report.js?vue&type=script&lang=js"
export * from "./report.js?vue&type=script&lang=js"

import "./report.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/opt/pleroma-fe/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__